import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Heart } from 'lucide-react';

const Footer = () => {
  const navigationItems = [
    { href: '/', label: 'Start' },
    { href: '/module', label: 'Module' },
    { href: '/seminartermine', label: 'Seminartermine' },
    { href: '/preise', label: 'Preise Ausbildung' }
  ];

  const moreItems = [
    { href: '/anmeldung', label: 'Anmeldung' },
    { href: '/behandlungen', label: 'Behandlungen' },
    { href: '/agb', label: 'AGB' },
    { href: '/impressum', label: 'Impressum' },
    { href: '/kooperationen', label: 'Kooperationen' },
    { href: '/lebenswerkstaetten', label: 'Lebenswerkstätten' }
  ];

  return (
    <footer className="bg-primary-deep text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Contact Information */}
          <div className="space-y-4">
            <h3 className="text-xl font-semibold mb-4 text-primary-light">Kontakt</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-primary-light" />
                <a 
                  href="mailto:sabrina.kure@yahoo.com"
                  className="hover:text-primary-light transition-colors"
                >
                  sabrina.kure@yahoo.com
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-primary-light" />
                <a 
                  href="tel:+436649703314"
                  className="hover:text-primary-light transition-colors"
                >
                  +43 664 9703314
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-primary-light mt-1" />
                <div>
                  <p>Sabrina Kure Energetik_und mehr</p>
                  <p>Mitteregg 24</p>
                  <p>8524 Deutschlandsberg</p>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="space-y-4">
            <h3 className="text-xl font-semibold mb-4 text-primary-light">Navigation</h3>
            <ul className="space-y-2">
              {navigationItems.map((item) => (
                <li key={item.href}>
                  <Link 
                    to={item.href}
                    className="hover:text-primary-light transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* More Links */}
          <div className="space-y-4">
            <h3 className="text-xl font-semibold mb-4 text-primary-light">Mehr</h3>
            <ul className="space-y-2">
              {moreItems.map((item) => (
                <li key={item.href}>
                  <Link 
                    to={item.href}
                    className="hover:text-primary-light transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Media */}
          <div className="space-y-4">
            <h3 className="text-xl font-semibold mb-4 text-primary-light">Folgen Sie uns</h3>
            <div className="flex space-x-4">
              <a 
                href="#" 
                className="flex items-center justify-center w-10 h-10 bg-primary-main rounded-full hover:bg-primary-light transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5 text-white" />
              </a>
              <a 
                href="#" 
                className="flex items-center justify-center w-10 h-10 bg-primary-main rounded-full hover:bg-primary-light transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5 text-white" />
              </a>
            </div>
            
            {/* WhatsApp Integration */}
            <div className="mt-6">
              <a 
                href="https://wa.me/436649703314" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 bg-green-600 hover:bg-green-700 px-4 py-2 rounded-lg transition-colors text-white"
              >
                <span>💬</span>
                <span>WhatsApp Chat</span>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright and Credit Section */}
        <div className="border-t border-primary-main/30 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center space-x-1 text-primary-lightest mb-4 md:mb-0">
            <span>Made with</span>
            <Heart className="h-4 w-4 text-red-500 fill-red-500" />
            <span>by</span>
            <a 
              href="https://digitalpro.dev/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-primary-light transition-colors font-medium underline"
            >
              DigitalPro
            </a>
          </div>
          <p className="text-primary-lightest">
            ©2025 von Sabrina Kure Energetik. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;